import React from "react";
import style from "../../scss/components/AdminPanel/_bookings.module.scss";

const Bookings = () => {
  return (
    <div className={style.container_bookings}>
      <div>
        <h2>Bookings</h2>
      </div>
    </div>
  );
};

export default Bookings;
